module.exports = __webpack_public_path__ + "static/asmet-color_white@2x-bc6d793d2473c6b9335985fd29442c9d.png";